'use client';

import { useBioUserAccess } from '../../contexts/user-access/useBioUserAccess';

/**
 * Client label for the visitor "Subscribe" main-action button: shows
 * "Subscribed" once the viewer follows or holds a subscription with this creator
 * (and isn't the owner), else the static `label`. Mirrors PopshopRN's
 * `subscribed && !isOwner ? 'Subscribed' : label`.
 *
 * The only client JS in the main-action row — `dm` / community keep their plain
 * server string. It reads the already-mounted `BioUserAccess` context (no new
 * fetch / context), so it adds no data cost or meaningful bundle weight.
 */
export function SubscribeLabel({ label }: { label: string }) {
  const { currentUserId, creatorId, isFollowing, extendedSubscriptionLevel } =
    useBioUserAccess();

  const isOwner = currentUserId != null && currentUserId === creatorId;
  const subscribed = isFollowing === true || extendedSubscriptionLevel != null;

  return <>{subscribed && !isOwner ? 'Subscribed' : label}</>;
}
